import type { FC } from 'react';
import React, { memo } from 'react';
import './index.scss';
import Badge from '../Badge';
import { useHistory } from '@compat/router';
import type { Badge as BadgeT } from '@utils/prepareBadges';
import { twcls } from '@utils/twcls';
import type { ClassValue } from 'clsx';

interface BadgesProps {
  badges: BadgeT[];
  isBehaveAsLink: boolean;
  className?: ClassValue;
}

const Badges: FC<BadgesProps> = ({
  badges,
  className,
  isBehaveAsLink = true
}) => {
  const history = useHistory();
  return (
    <noindex>
      <div className={twcls('badges', className)}>
        {badges.map(item => (
          <Badge
            key={item.id}
            icon={item.icon}
            displayNone={item.id === 'promotion'}
            order={item.order}
            title={item.title}
            tooltipText={item.tooltip}
            link={isBehaveAsLink ? item.link : null}
            backgroundColor={item.color}
            textColor={item.color === '#FFDC5C' ? '#363636' : '#fff'}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              if (!isBehaveAsLink) {
                return;
              }
              if (e.ctrlKey) {
                if (item.link) {
                  window.open(item.link, '_blank');
                }
              } else {
                if (item.link) {
                  history.push(item.link);
                }
              }
            }}
          />
        ))}
      </div>
    </noindex>
  );
};

export default memo(Badges);
